import(/* webpackMode: "eager" */ "/opt/render/project/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/components/FacebookPixel.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/components/layout/Footer.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/components/layout/Navbar.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/metrics/MicrosoftClarity.jsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/next/font/google/target.css?{\"path\":\"app/layout.js\",\"import\":\"Poppins\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\"],\"variable\":\"--font-Poppins\"}],\"variableName\":\"poppins\"}");
